import React from 'react';
import { T } from 'src/shared/helpers';
import styled from 'styled-components';
import { Badge } from '../badge';
import { ZTooltip } from '../ztooltip';

// ZTooltip anchors itself through the child's ref, which Badge does not forward.
const DemoBadgeAnchor = styled.span`
    display: inline-flex;
`;

const DemoTooltipContent = styled.span`
    display: block;
    max-width: 260px;
`;

interface DemoTypeBadgeProps {
    tooltip: string;
    'data-testid'?: string;
}

/** The «Demo» type pill, with a tooltip that explains what the demo item is for. */
export const DemoTypeBadge = ({ tooltip, 'data-testid': testId }: DemoTypeBadgeProps) => (
    <ZTooltip position='top' html={<DemoTooltipContent>{tooltip}</DemoTooltipContent>}>
        <DemoBadgeAnchor data-testid={testId}>
            <Badge variant='demo'>{T._('Demo', 'Admin')}</Badge>
        </DemoBadgeAnchor>
    </ZTooltip>
);

export const getDemoProductTooltip = () =>
    T._('This is a demo product that shows how the customizer works and how a product is set up. You can duplicate it to copy its configuration.', 'Admin');

interface ProductSourceBadgeProps {
    provider?: string | null;
    ecommerceName?: string | null;
}

export const ProductSourceBadge = ({ provider, ecommerceName }: ProductSourceBadgeProps) => {
    if (provider !== 'ZAKEKE') return <Badge variant='pod'>{T._('POD', 'Admin')}</Badge>;

    if (ecommerceName === 'NONE') return <Badge variant='standalone'>{T._('Standalone', 'Admin')}</Badge>;

    return <Badge variant='store'>{T._('Store', 'Admin')}</Badge>;
};
